export function headerOr(predicate) {
    return (task) => task.isHeader || predicate(task)
}
